import { Component, Inject, OnInit, OnDestroy, Type } from '@angular/core';
import _ from 'lodash';
import { ClientLoggerService } from '../../services/client-logger.service';
import { PerformanceMetricsService } from '../../services/performance-metrics.service';
import { MySynchEnumerationService } from '../../services/mysynch.enumeration.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { PerformanceContextService } from '../../services/performance-context.service';


import {Tab,PerformanceContext} from '../../interfaces/mysynch.interfaces';

import { TMTestFarmsView } from './views/tm-test-farms-view/tm-test-farms-view.component';
import { TMActiveFarmsView } from './views/tm-active-farms-view/tm-active-farms-view.component';
import { TMInactiveFarmsView } from './views/tm-inactive-farms-view/tm-inactive-farms-view.component';

@Component({
    standalone: false,
    selector: 'tm-dashboard',
    templateUrl: '../app/pages/tm-dashboard/tm-dashboard.view.html',
    styleUrls: ['../app/pages/tm-dashboard/tm-dashboard.style.css']
    })
export class TMDashboard implements OnInit , OnDestroy{

    
    private defaultTabName: string = "test-farms";
    private activeTab: Tab | undefined = undefined;
    private performanceContext: PerformanceContext | undefined = undefined;

    isMobile:boolean = false;
    loading:boolean = true;

    tabSetId: string = "tmDashboardTabSet";
    tabs: Tab[] = [
        {
            title: "Test Farms",
            name:"test-farms",
            selected: false
        },
        {
            title: "Active Farms",
            name:"active-farms",
            selected: false
        },
        {
            title: "Inactive Farms",
            name:"inactive-farms",
            selected: false
        }
    ]
     viewMap: { [key: string]: Type<any> } = {
        'test-farms': TMTestFarmsView,
        'active-farms': TMActiveFarmsView,
        'inactive-farms': TMInactiveFarmsView
    };

        constructor(@Inject('MySynchFactory') private MSF:any,
                    @Inject('ApiFactory') private api:any,
                    @Inject('CookieFactory') private cookies:any,
                    @Inject(PerformanceMetricsService) private perfMetricSvc:PerformanceMetricsService,
                    @Inject(PerformanceContextService) private perfContextSvc:PerformanceContextService,
                    @Inject(DeviceDetectorService) private deviceDetector:DeviceDetectorService,
                    @Inject(ClientLoggerService) private log:ClientLoggerService
    ){
        this.isMobile = deviceDetector.isMobile();
    }
    
			
			
    add() {
        this.MSF.loadPage('NewFarm');
    };


    loadReport() {
        return new Promise<void>((resolve, reject) => {
            this.perfMetricSvc.startTiming("Page:TerritoryDashboard:Build");
            var selectedTabName = _.get(this.MSF,'state.params.selectedTabName')
            if(_.isEmpty(selectedTabName)){
                selectedTabName = this.defaultTabName;
            }
            let selectedTab = _.find(this.tabs,{name:selectedTabName}) as Tab;
            if(_.isUndefined(selectedTab)){
                selectedTab = this.tabs[0];
            }
            _.set(selectedTab,'selected',true);
            this.activeTab = selectedTab;
            this.perfMetricSvc.endTiming("page","Page:TerritoryDashboard:Build", this.performanceContext);
            resolve();
        });
        
    }

    ngOnInit() {
        this.MSF.ready(() => {
            this.performanceContext = this.perfContextSvc.createPerformanceContext();
            this.perfMetricSvc.startTiming("Page:TerritoryDashboard:Render");
				 
            this.loadReport().then(() => {
            this.perfMetricSvc.markPageReady("Page:TerritoryDashboard:Render", this.performanceContext);
            this.loading = false;
            });
        });
    }

    ngOnDestroy() {
        this.performanceContext = undefined;
    }

}

        